// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__Vl9P4","header":"Layout_header__LTb5V","body":"Layout_body__cGonb"};